import { Typography } from "antd";
import { useNavigate, useParams } from "react-router-dom";

import { AdminMenuLayout } from "../../../shared/components";
import { accompanimentsService } from "../../../shared/services";
import { DrawerAccompaniments } from "./styled";
import { EditAccompanimentForm } from "./form";
import React from "react";
import { IAccompaniment } from "../../../redux/@types";

const { Text } = Typography;

export const AccompanimentById = () => {
  const { accompaniment_id } = useParams<{ accompaniment_id: string }>();
  const navigate = useNavigate();
  const [accompaniment, setAccompaniment] = React.useState<IAccompaniment | undefined>();

  React.useEffect(() => {
    if (accompaniment_id) {
      accompanimentsService
        .get(Number(accompaniment_id))
        .then((res: any) => setAccompaniment(res))
        .catch(() => setAccompaniment(undefined));
    }
  }, [accompaniment_id]);

  const handleSuccess = () => {
    if (accompaniment_id) {
      accompanimentsService.get(Number(accompaniment_id)).then((res: any) => setAccompaniment(res));
    }
  };

  if (!accompaniment_id) {
    return (
      <AdminMenuLayout pageDescription="Acompañamientos" title="Acompañamientos">
        <Text style={{ color: "gray" }}>ID no válido</Text>
      </AdminMenuLayout>
    );
  }

  return (
    <AdminMenuLayout pageDescription="Acompañamientos" title="Acompañamientos">
      <div style={{ padding: "10px" }}>
        <Text
          style={{ color: "gray", cursor: "pointer" }}
          onClick={() => navigate("/accompaniments")}
        >
          ← Volver a acompañamientos
        </Text>
      </div>
      <DrawerAccompaniments
        title="Editar acompañamiento"
        open={!!accompaniment}
        width={420}
        centered
        destroyOnClose
        footer={null}
        onCancel={() => navigate("/accompaniments")}
      >
        <EditAccompanimentForm accompaniment={accompaniment} onSuccess={handleSuccess} />
      </DrawerAccompaniments>
    </AdminMenuLayout>
  );
};
